
export default function Footer() {
  const services = [
    'Branding',
    'Diseño e Identidad',
    'Web Design',
    'Estrategia de Marca',
    'Packaging'
  ];

  const socialLinks = [
    { icon: 'ri-instagram-line', href: '#', label: 'Instagram' },
    { icon: 'ri-linkedin-line', href: '#', label: 'LinkedIn' },
    { icon: 'ri-behance-line', href: '#', label: 'Behance' },
    { icon: 'ri-dribbble-line', href: '#', label: 'Dribbble' }
  ];

  return (
    <footer className="bg-[#0f0f23] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="mb-6">
              <h3 className="text-3xl font-bold">
                <span className="text-[#9EFF00]">RE</span>
                <span className="text-white">BRANDING</span>
              </h3>
              <p className="text-gray-400 mt-2 text-sm">Diseño & Innovación</p>
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              Transformamos marcas a través del diseño estratégico y la innovación. 
              Creamos identidades visuales que conectan, comunican y convierten.
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-[#9EFF00] text-gray-300 hover:text-black rounded-lg transition-all duration-200"
                  aria-label={social.label}
                >
                  <i className={social.icon}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Servicios</h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service}>
                  <a href="#servicios" className="text-gray-300 hover:text-[#9EFF00] transition-colors duration-200">
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Contacto</h4>
            <div className="space-y-3 text-gray-300">
              <div className="flex items-center space-x-3">
                <i className="ri-mail-line text-[#9EFF00]"></i>
                <span>hola@rebranding.cl</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-phone-line text-[#9EFF00]"></i>
                <span>+56 9 1234 5678</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-map-pin-line text-[#9EFF00]"></i>
                <span>Santiago, Chile</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 Rebranding. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
